import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Layout Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import Events from './pages/Events';
import Work from './pages/Work';
import Calendar from './pages/Calendar';
import Donate from './pages/Donate';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-[#EBDCCD] text-[#121212] selection:bg-[#D4B896] selection:text-[#2C1A14]">
        <Navbar />

        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/events" element={<Events />} />
            <Route path="/work" element={<Work />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/donate" element={<Donate />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;